module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/comment-stars-four-0e79f259884cb271bdf1868770638d56.png";